/**
 * LiveIndicator — dot pulsante "ao vivo" + last updated.
 */
import { formatRelative } from "@/lib/format";
import { cn } from "@/lib/utils";

interface Props {
  lastUpdated: string | Date | null;
  isFetching?: boolean;
  className?: string;
}

export function LiveIndicator({ lastUpdated, isFetching, className }: Props) {
  const iso = typeof lastUpdated === "string" ? lastUpdated : lastUpdated?.toISOString() ?? null;
  return (
    <div className={cn("inline-flex items-center gap-1.5 text-[11px] text-muted-foreground", className)}>
      <span className="relative inline-flex h-1.5 w-1.5">
        <span
          className={cn(
            "absolute inline-flex h-full w-full rounded-full opacity-75",
            isFetching ? "animate-ping bg-amber-500" : "animate-ping bg-emerald-500",
          )}
        />
        <span
          className={cn(
            "relative inline-flex h-1.5 w-1.5 rounded-full",
            isFetching ? "bg-amber-500" : "bg-emerald-500",
          )}
        />
      </span>
      <span className="tabular-nums">
        {isFetching ? "atualizando" : iso ? formatRelative(iso) : "ao vivo"}
      </span>
    </div>
  );
}
